module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "storekeeper-freights"
    }
  }, [_c('div', {
    staticClass: "md-layout heading"
  }), _c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('storekeepers-menu'), _c('sort-table', {
    ref: "storekeepers-freights-table",
    attrs: {
      "columns": _vm.tableColumns,
      "link": true,
      "per-page": _vm.perPage,
      "total": _vm.freightAmount,
      "default-order": "desc",
      "table-id": "storekeepers-freights-table",
      "tableHeight": "calc(100% - 48px)",
      "showAddButton": false,
      "refreshOnCreate": false,
      "loadOnScroll": true,
      "noBreackColumns": ['traking_number', 'id']
    },
    on: {
      "refresh": _vm.getFreights
    },
    scopedSlots: _vm._u([{
      key: "id",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.item.traking_number))])]
      }
    }, {
      key: "weight",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((scope.item.weight) ? scope.item.weight : 'Не установлен'))])]
      }
    }, {
      key: "size",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((scope.item.size) ? scope.item.size : 'Не установлен'))])]
      }
    }, {
      key: "seats_number",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((scope.item.seats_number) ? scope.item.seats_number : 'Не установлен'))])]
      }
    }, {
      key: "status",
      fn: function(scope) {
        return [(scope.item.status) ? _c('span', {
          style: ('color: ' + scope.item.status.color)
        }, [_vm._v(_vm._s(scope.item.status.name))]) : _vm._e(), (!scope.item || !scope.item.status) ? _c('span', [_vm._v("Не установлен")]) : _vm._e()]
      }
    }, {
      key: "from",
      fn: function(scope) {
        return [(scope.item.deal && (scope.item.deal.from_stock || scope.item.deal.from_address)) ? _c('div', [(scope.item.deal.from_stock) ? _c('span', [_vm._v(_vm._s(scope.item.deal.from_stock.name))]) : _vm._e(), (scope.item.deal.from_address) ? _c('span', [_vm._v(_vm._s(scope.item.deal.from_address.address))]) : _vm._e()]) : _c('div', [(scope.item.deal && scope.item.deal.from_city) ? _c('span', [_vm._v(_vm._s(scope.item.deal.from_city.name))]) : _vm._e()])]
      }
    }, {
      key: "to",
      fn: function(scope) {
        return [(scope.item.deal && (scope.item.deal.to_stock || scope.item.deal.to_address)) ? _c('div', [(scope.item.deal.to_stock) ? _c('span', [_vm._v(_vm._s(scope.item.deal.to_stock.name))]) : _vm._e(), (scope.item.deal.to_address) ? _c('span', [_vm._v(_vm._s(scope.item.deal.to_address.address))]) : _vm._e()]) : _c('div', [(scope.item.deal && scope.item.deal.to_city) ? _c('span', [_vm._v(_vm._s(scope.item.deal.to_city.name))]) : _vm._e()])]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return undefined
      }
    }]),
    model: {
      value: (_vm.freights),
      callback: function($$v) {
        _vm.freights = $$v
      },
      expression: "freights"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('div', {
    staticClass: "button-container"
  }, [_c('md-button', {
    staticClass: "md-dense md-primary",
    attrs: {
      "to": {
        name: 'StorekeepersFreight',
        params: {
          id: 'new'
        }
      }
    }
  }, [_vm._v("Принять груз")]), _c('md-button', {
    staticClass: "md-dense md-accent",
    attrs: {
      "to": {
        name: 'StorekeepersIssueFreight'
      }
    }
  }, [_vm._v("Выдать груз")])], 1)])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-450b72f3","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/Freights.vue
// module id = 1123
// module chunks = 0